var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 16C32 24.8368 24.8361 32 16.0004 32C7.16385 32 0 24.8368 0 16C0 7.16318 7.16385 0 16.0004 0C24.8361 0 32 7.16318 32 16",
  fill: "#E4E3E6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.6866 16.0008L22.8236 10.8647C23.2894 10.3988 23.2894 9.64341 22.8236 9.17753C22.3577 8.71166 21.6024 8.71166 21.1375 9.17753L16.0005 14.3146L10.8636 9.17753C10.3978 8.71166 9.64338 8.71166 9.17752 9.17753C8.71166 9.64341 8.71166 10.3988 9.17752 10.8647L14.3144 16.0008L9.17752 21.1379C8.71166 21.6037 8.71166 22.3581 9.17752 22.824C9.41045 23.057 9.71623 23.173 10.0211 23.173C10.3259 23.173 10.6307 23.057 10.8636 22.824L16.0005 17.6869L21.1375 22.824C21.3704 23.057 21.6752 23.173 21.98 23.173C22.2848 23.173 22.5906 23.057 22.8236 22.824C23.2894 22.3581 23.2894 21.6037 22.8236 21.1379L17.6866 16.0008Z",
  fill: "url(#paint0_linear_111_3511)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.6866 16.0008L22.8236 10.8647C23.2894 10.3988 23.2894 9.64341 22.8236 9.17753C22.3577 8.71166 21.6024 8.71166 21.1375 9.17753L16.0005 14.3146L10.8636 9.17753C10.3978 8.71166 9.64338 8.71166 9.17752 9.17753C8.71166 9.64341 8.71166 10.3988 9.17752 10.8647L14.3144 16.0008L9.17752 21.1379C8.71166 21.6037 8.71166 22.3581 9.17752 22.824C9.41045 23.057 9.71623 23.173 10.0211 23.173C10.3259 23.173 10.6307 23.057 10.8636 22.824L16.0005 17.6869L21.1375 22.824C21.3704 23.057 21.6752 23.173 21.98 23.173C22.2848 23.173 22.5906 23.057 22.8236 22.824C23.2894 22.3581 23.2894 21.6037 22.8236 21.1379L17.6866 16.0008Z",
  fill: "#1A90FF"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_111_3511",
  x1: 16.0005,
  y1: 8.82812,
  x2: 16.0005,
  y2: 23.173,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4E71E2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8540CB"
})));

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.0130771c3d05da9a39d86d92c63e6969.svg";
export { ForwardRef as ReactComponent };